<template>
  <v-container grid-list-md fluid ma-0 pa-0>
    <v-layout row wrap ma-0 pa-0 t>
      <v-flex xs12 pb-5 height700 hero-image mb-5>
        <!--<v-img :src="/assets/bg.jpg"></v-img>-->
          <v-layout align-end row fill-height>
            <v-flex xs8 offset-xs2 align-end display-2 text-uppercase class="wsh-center" :class="{'headline': $vuetify.breakpoint.smAndDown}">
              <span class="call-to-subtitle">Call now to order</span>
              <br/> 
              <br/>
              <span class="call-to-action"><a href="tel:888-444-0599" class="no-style-link">888-440-0599</a></span>
              <br/>
              <br/>
              <br/>
              According to HomeAdvisor<span class="caption super">®</span>, <br>75% of new homeowners will face an unexpected home emergency within the first year.<span class="super subheading">*</span>
            </v-flex>

          </v-layout>

      </v-flex>

    </v-layout>
    <v-layout row wrap darkblue>
      <v-flex xs8 offset-xs2 py-5>


        That’s a pretty amazing statistic. But what’s even more amazing is that most new homeowners aren’t prepared to cover the cost of repairing or replacing a major appliance or system in their new home if it breaks. That’s why you should consider getting coverage from Home Solutions Warranty.
        <br>
        <br>

        For just $62 a month, you can relax knowing that if any covered item breaks during the home warranty term, we’ll pay to make it right. We’ll even let you pick who does the repair.
        <br>
        <br>

        Other statistics we think new homeowners should know.**

      </v-flex>


      <v-flex xs8 offset-xs2 py-5>
        <v-layout row wrap>
          <v-flex xs4 :class="{'xs12': $vuetify.breakpoint.smAndDown}">
            <div class="display-4" >
              <i class="fal fa-tools"></i>
            </div>
            <br>
            <div class="display-2">
              57%
            </div>
            <br>
            take on more home improvement projects than planned.

          </v-flex>

          <v-flex xs4 :class="{'xs12': $vuetify.breakpoint.smAndDown}">
            <div class="display-4">
              <i class="fal fa-stopwatch"></i>
            </div>
            <br>
            <div class="display-2">
              51%
            </div>
            <br>
            wind up spending more time on each project than planned.

          </v-flex>

          <v-flex xs4 :class="{'xs12': $vuetify.breakpoint.smAndDown}">
            <div class="display-4">
              <i class="fal fa-hand-holding-usd"></i>
            </div>
            <br>
            <div class="display-2">
              46%
            </div>
            <br>
            spend more on home projects than they thought they would.

          </v-flex>
        </v-layout>
      </v-flex>

    </v-layout>
    <v-layout row wrap py-5>


      <v-flex xs3 title mr-5 text-uppercase class="hsw-lineheight" :class="{'xs10':$vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown, 'offset-xs2':$vuetify.breakpoint.mdAndUp}" >
        The Home<br>Solutions Warranty:
        Real coverage basedon real information.

      </v-flex>
      <v-flex xs4 :class="{'xs10':$vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown}">
        Many home warranty companies like to boast about having comprehensive coverage. But Home Solutions Warranty bases our protection on real information: a home inspection.
        <br>
        <br>

        A unique feature of our program is that it covers existing defects or mechanical failures on covered components that were not detected during your home inspection. In short, if a covered item fails and the inspector didn’t document any issues with it…we’ll pay for repair or replacement!<span class="super caption">*</span>
        <br>
        <br>
        This affordable optional protection covers major home systems as well as key appliances — and can dramatically reduce out of pocket costs in case a covered system or appliance fails during the first 15 months of home ownership.

      </v-flex>

    </v-layout>
    <v-layout row wrap py-3>

      <v-flex xs3 offset-xs2 mr-5 :class="{'xs10':$vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown}">
        <img class="max100" src="@/assets/applianceBliss.jpg">
      </v-flex>
      <v-flex xs4 :class="{'xs10':$vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown}" >
        <div class="title pb-3 text-uppercase">
          Valuable protection<br>for peace of mind
        </div>


        For many people, budgets can be quite tight in the weeks and months after closing, and unplanned expenses can wreak real havoc on a household budget — it can sometimes take years to recover.
        <br><br>
        With the Home Solutions Warranty, you have protection against this possibility for $43 a month. An online registration portal means you can protect yourself without leaving your home. You can even add additional coverage if you’d like. What’s more, the warranty is renewable at the end of the term.
      </v-flex>

    </v-layout>
    <v-layout row wrap py-5>


      <v-flex xs3 mr-5 :class="{'xs10':$vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown, 'offset-xs2':$vuetify.breakpoint.mdAndUp}">
        <div class="title pb-3 text-uppercase">
          Use our contractors<br>
          or yours!
        </div>

        When a problem arises, simply call our claims department and we will dispatch one of our pre-screened, highly qualified licensed contractors. Or, if you prefer, you may use a contractor of your choosing — the only requirement is that they must obtain prior authorization and need to be state licensed and insured.

      </v-flex>
      <v-flex xs4 :class="{'xs10':$vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown}">
        <img src="@/assets/contractorBliss.jpg" class="max100">
      </v-flex>
      <v-flex xs8 offset-xs2 display-1 py-5 class="wsh-center text-uppercase" :class="{'headline': $vuetify.breakpoint.smAndDown}">
        Homebuyers can enjoy comprehensive coverage on the following systems and elements of a home:
      </v-flex>

      <v-flex xs3 :class="{'offset-xs2':$vuetify.breakpoint.mdAndUp, 'offset-xs1':$vuetify.breakpoint.smAndDown}">
        <ul class="fa-ul">
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Clearing of Line Stoppages</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Non-detected Pre-existing Conditions*	</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Permits & Code Violations</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Improper Installation</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Removal of Defective Equipment</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Refrigerant Recapture and Disposal</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Central Air System</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Central Heating System</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Ductwork</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Dishwasher</li>
        </ul>
      </v-flex>

      <v-flex xs3>
        <ul class="fa-ul">
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Garbage Disposal</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Microwave	</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Oven, Range and Cooktop</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Water Heaters	</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Sump Pump	</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Whirlpool Motor & Jets</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Electrical</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Grinder Pump</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Kitchen Refrigerator</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Trash Compactor</li>
        </ul>
      </v-flex>

      <v-flex xs3>
        <ul class="fa-ul">
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Humidifier/ Dehumidifier</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Electronic Air Filters</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Gas Fireplace Burner Unit	</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Shower Heads	</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Faucets & Fixtures</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Ceiling and Attic Fans</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Water Softener</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Sewer Ejector Pumps</li>
          <li><span class="fa-li" ><i class="fal fa-check"></i></span>Geothermal HVAC</li>
        </ul>
      </v-flex>



    </v-layout>
    <v-layout row wrap py-5 class="lightblue">
      <v-flex xs8 offset-xs2 display-2 class="wsh-center text-uppercase" :class="{'headline': $vuetify.breakpoint.smAndDown}">
        It’s easy to see why our home warranty makes real sense.
      </v-flex>

      <v-layout row wrap>
        <v-flex class="wsh-center" pt-5  xs2 offset-md2 :class="{'xs10': $vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown}">
          <div class="display-4 blueicons">
            <i class="fal fa-rabbit-fast"></i>
          </div>
        <br>
          Easy to Activate:<br>
          Sign up online for as
          little as $62/month
        </v-flex>
        <v-flex class="wsh-center" pt-5  xs2 offset-md1 :class="{'xs10': $vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown}">
          <div class="display-4 blueicons">
            <i class="fal fa-poll-people"></i>
          </div>
          <br>
          Your Choice
          of Contractors:<br>
          We’ll pay to repair or replace — you pick the provider
        </v-flex>
        <v-flex class="wsh-center" pt-5  xs2 offset-md1 :class="{'xs10': $vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown}">
          <div class="display-4 blueicons">
            <i class="fal fa-house-damage"></i>
          </div>
          <br>
          Reduced Claim Denials:<br>
          Claims will not be denied
          based on non-detected
          pre-existing condition**
        </v-flex>

        <v-flex class="wsh-center" pt-5  xs2 offset-md4 :class="{'xs10': $vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown, 'hsw-left28': $vuetify.breakpoint.mdAndUp}">
          <div class="display-4 blueicons">
            <i class="fal fa-clipboard-list-check"></i>
          </div>
          <br>
          Up to $25,000
          of Protection:<br>
          Covers major home systems & appliances for 15 months

        </v-flex>

        <v-flex class="wsh-center" style="margin-left: 9.6%" pt-5  xs2 offset-xs1 :class="{'xs10': $vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown}">
          <div class="display-4 blueicons">
            <i class="fal fa-calendar-alt"></i>
          </div>
          <br>
          Longer Term for Less:<br>
          Our warranty offers protection for up to 15 months — a longer term at a lower price than most home warranties
        </v-flex>
        <v-flex md4 offset-md4 caption class="wsh-center">
          *Source: https://www.homeadvisor.com/r/new-homeowner-tips-projects/
          **Coverage is subject to policy’s terms and conditions. Preexisting conditions are covered if the condition is not identified in a home inspection report and the home warranty was purchased within 90 days of the home inspection.
        </v-flex>
      </v-layout>


    </v-layout>
    <v-layout row wrap py-5 class="wsh-cta">


      <v-flex xs8 offset-xs2 display-3  py-5 class="wsh-center text-uppercase" :class="{'headline': $vuetify.breakpoint.smAndDown}">
        Enjoy real peace of mind
        for as little as $62/month.
        <br/>
        <v-btn outline color="white" @click.stop="openTerms">
          Terms and Conditions
        </v-btn>
      </v-flex>

      <!--<v-flex xs3 offset-xs3 :class="{'xs10': $vuetify.breakpoint.smAndDown, 'offset-xs1':$vuetify.breakpoint.smAndDown}">
        <v-btn outline color="white" @click.stop="openDialog">
          Click here to `order
        </v-btn>
      </v-flex>
      <v-flex xs3 :class="{'xs10': $vuetify.breakpoint.smAndDown, 'offset-xs3':$vuetify.breakpoint.smAndDown}">
        <v-btn outline color="white" @click.stop="openTerms">
          Terms and Conditions
        </v-btn>
      </v-flex>-->

    </v-layout>

    <!--<v-dialog-->
            <!--v-model="dialog"-->
            <!--max-width="80%"-->
    <!--&gt;-->

        <!--<warranty-form/>-->

    <!--</v-dialog>-->


  </v-container>


</template>

<script>


  export default {
    data: () => ({
      dialog: false,
      takingOrders: false,
      ecosystem: [
        {
          text: 'vuetify-loader',
          href: 'https://github.com/vuetifyjs/vuetify-loader'
        },
        {
          text: 'github',
          href: 'https://github.com/vuetifyjs/vuetify'
        },
        {
          text: 'awesome-vuetify',
          href: 'https://github.com/vuetifyjs/awesome-vuetify'
        }
      ],
      importantLinks: [
        {
          text: 'Documentation',
          href: 'https://vuetifyjs.com'
        },
        {
          text: 'Chat',
          href: 'https://community.vuetifyjs.com'
        },
        {
          text: 'Made with Vuetify',
          href: 'https://madewithvuetifyjs.com'
        },
        {
          text: 'Twitter',
          href: 'https://twitter.com/vuetifyjs'
        },
        {
          text: 'Articles',
          href: 'https://medium.com/vuetify'
        }
      ],
      whatsNext: [
        {
          text: 'Explore components',
          href: 'https://vuetifyjs.com/components/api-explorer'
        },
        {
          text: 'Select a layout',
          href: 'https://vuetifyjs.com/layout/pre-defined'
        },
        {
          text: 'Frequently Asked Questions',
          href: 'https://vuetifyjs.com/getting-started/frequently-asked-questions'
        }

      ]
    }),
    methods: {
      openDialog() {
        console.log('OPEN DIALOG IN CHILD COMPONENT');
        this.$emit('openTheOrderForm');
      },
      openTerms() {
        this.$emit('openTheTermSheet');
      }
    }
  }
</script>

<style>
  .super {
    vertical-align: super;
    position: relative;
    top: -.5em;
  }
  .hsw-lineheight {
    line-height: 1.4 !important;
  }
  .hsw-left28 {
    margin-left: 28% !important;
  }
  .call-to-action {
    font-size: 3em;
    font-weight: 700;
    color: #fff;
    text-shadow: 0 0 20px rgba(0,0,0,.5);
  }
  .call-to-subtitle {
    font-size: 1em;
    text-shadow: 0 0 20px rgba(0,0,0,.5);
  }
  .no-style-link {
    color: inherit; 
    text-decoration: none; /* no underline */
  }
  /* If screensize is mobile then make the font size on the call to action smaller */
  @media only screen and (max-width: 600px) {
    .call-to-action {
      font-size: 2em;
    }
  }
</style>
